import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class PostDislikesModalState extends PaginatedListState {
  constructor(params, page = 1) {
    const limit = 10;
    params.page = {
      ...(params.page || {}),
      limit
    };
    super(params, page, limit);
  }
  get type() {
    return 'users';
  }
}
flarum.reg.add('nodeloc-dislikes', 'forum/states/PostDislikesModalState', PostDislikesModalState);